import Payment from 'models/Payment'
import { observable } from 'mobx';

class Reserve {

  @observable checked_in

  constructor(json = {}) {
    this.checked_in = json.checked_in
    this.created_at = json.created_at
    this.document = json.document
    this.fk_package = json.fk_package
    this.fk_payment = json.fk_payment
    this.fk_request = json.fk_request
    this.fk_team = json.fk_team
    this.fk_user = json.fk_user
    this.is_deleted = json.is_deleted
    this.name = json.name
    this.email = json.email
    this.birthday = json.birthday
    this.phone = json.phone
    this.order_id = json.order_id
    this.order_status = json.order_status

    const pckg = json.package || json.requestPackage || {}

    this.packageName = pckg.name
    this.packagePrice = pckg.priceWithDiscount ? pckg.priceWithDiscount : pckg.price
    this.packagePrice = Number(this.packagePrice)

    this.payment = new Payment(json.payment)
    this.pk_reserve = json.pk_reserve
    this.short_url = json.short_url
    this.status = json.status
    this.token = json.token
    this.custom_fields = json.custom_fields || []
    this.updated_at = json.updated_at
    this.user = json.user || {}
  }

}

export default Reserve


// WEBPACK FOOTER //
// ./src/models/Reserve.js